export function stripHtmlTags(input: string): string {
    const tagPattern = /<[^>]*>/g;
    let result = input;
    while (tagPattern.test(result)) {
        result = result.replace(tagPattern, '');
    }
    return result;
}
